import {styled} from "@mui/material";
import ThemedText from "../../../components/text";
import Label from "../../../resources/label";
import Base from "../../../components/base";
import LoginForm from "../../../components/form/login";
import {useNavigate} from "react-router-dom";
import {buildPath, scale} from "../../../utils";
import {User} from "../../../types";
import {useEffect} from "react";


const Wrapper = styled('div')({
  maxWidth: scale(1592),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  marginTop: scale(50),
  rowGap: scale(38),
});

const Login = () => {
  const navigate = useNavigate();
  const userData = localStorage.getItem('user')
  const user: User | null = userData ? JSON.parse(userData) as User : null;

  useEffect(() => {
    if (user?.role === 'OPERATOR') {
      navigate(buildPath('/operatore/calendario'))
    }
  }, [navigate, user?.role])

  return (
    <Wrapper>
      <ThemedText
        fontSize={scale(42)}
        align={'center'}
        fontWeight={300}
        lineHeight={scale(52)}
        letterSpacing={scale(0.42)}
        text={Label.LOGIN_HEADER}
      />
      <Base
        style={{
          width: scale(500),
          height: scale(560),
      }}>
        <LoginForm
          style={{
            marginTop: scale(50),
            marginBottom: scale(58),
            height: '100%',
          }}
          onLoginSuccess={() => navigate(buildPath('/operatore/calendario'))}
          admin={false}
        />
      </Base>
    </Wrapper>
  );
};

export default Login;
